import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import { Collaboration } from '@models/Collaboration';
import { CollaborationApi } from '@apis/CollaborationApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';
import { getResponseError } from '@utils/error';

import {
  collaborationsFetch,
  CollaborationsFetchPayload,
  collaborationCreate,
  CollaborationCreatePayload,
  collaborationUpdate,
  CollaborationUpdatePayload,
  collaborationDelete,
  CollaborationDeletePayload,
  stateUpdate,
  StateUpdatePayload,
  stateReload,
} from './action';

function* handleCollaborationsFetch({ payload }: SagaPayload<CollaborationsFetchPayload>) {
  const state: StateUpdatePayload = { collaborations: null, pagination: undefined };
  try {
    const [collaborations, pagination] = (yield call(CollaborationApi.getAll, payload)) as [Collaboration[], Pagination];
    state.collaborations = collaborations;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCollaborationCreate({ payload }: SagaPayload<CollaborationCreatePayload>) {
  try {
    yield call(CollaborationApi.create, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

function* handleCollaborationUpdate({ payload }: SagaPayload<CollaborationUpdatePayload>) {
  try {
    yield call(CollaborationApi.update, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

function* handleCollaborationDelete({ payload }: SagaPayload<CollaborationDeletePayload>) {
  try {
    yield call(CollaborationApi.delete, payload);
    yield put(stateReload());
  } catch { }
}

export default function* () {
  yield takeLatest(collaborationsFetch, handleCollaborationsFetch);
  yield takeLatest(collaborationCreate, handleCollaborationCreate);
  yield takeLatest(collaborationUpdate, handleCollaborationUpdate);
  yield takeLatest(collaborationDelete, handleCollaborationDelete);
}
